import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="time-activity-modal"
export default class extends Controller {
  static targets = ["customerId", "itemId", "projectId", "planId", "duration"]
  static outlets = ["autocomplete"]

  connect() {
    // Only auto-focus customer field on new entries (no customer selected yet)
    const customerAutocomplete = this.findAutocompleteOutletById("time_activity_customer_id_wrapper")
    if (customerAutocomplete && !customerAutocomplete.hiddenTarget.value) {
      customerAutocomplete.setFocus()
    }
  }

  findAutocompleteOutletById(id) {
    return this.autocompleteOutlets.find(outlet =>
      outlet.element.id === id
    )
  }

  setFocusToCustomer() {
    const customerAutocomplete = this.findAutocompleteOutletById("time_activity_customer_id_wrapper")
    if (customerAutocomplete)
      customerAutocomplete.setFocus()
  }

  setFocusToItem() {
    this.focusAutocompleteById("time_activity_item_id_wrapper")
  }

  focusAutocompleteById(id) {
    const ac = this.findAutocompleteOutletById(id)
    if (ac) {
      ac.setFocus()
      return true
    }
    return false
  }

  setFocusToDuration() {
    if (this.hasDurationTarget) this.durationTarget.focus()
  }

  update(event) {
    switch (event.target.name) {
      case 'time_activity[customer_id]':
        this.loadCustomerFields(event.target.value)
        break
      case 'time_activity[item_id]':
        this.focusAutocompleteById("time_activity_project_id_wrapper")
          || this.focusAutocompleteById("time_activity_plan_id_wrapper")
          || this.setFocusToDuration()
        break
      case 'time_activity[project_id]':
        this.focusAutocompleteById("time_activity_plan_id_wrapper")
          || this.setFocusToDuration()
        break
      case 'time_activity[plan_id]':
        this.setFocusToDuration()
        break
    }
  }

  async loadCustomerFields(customerId) {
    let url = "/time_activities/customer_fields"
    if (customerId) {
      url += `?customer_id=${customerId}`
    }

    const response = await fetch(url, {
      headers: { "Accept": "text/vnd.turbo-stream.html" }
    })
    const html = await response.text()
    Turbo.renderStreamMessage(html)

    // After Turbo replaces the DOM, focus the item field
    requestAnimationFrame(() => {
      this.setFocusToItem()
    })
  }
}
